/**
 * Module definition for all common implementations.
 *
 * @module stack.common
 */
angular.module('stack.common.api.queue', [
  'stack.common.api.queue.QueueService'
]);
